import { CheckEmailIcon, TestEmailIcon } from 'src/assets/inboxHub/InboxHubIcons'
import { Box, Dialog, DialogContent, DialogTitle, Divider, Stack, Typography, IconButton } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { useTheme } from '@mui/system'
import React from 'react'

const EmailMetricsSnapshotDialog = ({ showMetricsDialog, setShowMetricsDialog, emailMetrics, handleClickCheckEmail, BlueButton, WhiteButton, BorderLinearProgress }) => {
  const theme = useTheme()
  return (
    <>
      <Dialog
        open={showMetricsDialog}
        onClose={() => setShowMetricsDialog(false)}
        maxWidth='sm'
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            margin: { xs: 2, sm: 3 }
          }
        }}
      >
        <DialogTitle sx={{ pb: 1, position: 'relative' }}>
          <Typography sx={{ fontSize: { xs: '14px', md: '16px' }, fontWeight: 700 }}>
            Email Metrics Snapshot
          </Typography>
          <Typography sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 400 }} color='#8181B0'>
            See metrics to quickly assess your email's performance.
          </Typography>
          <IconButton
            onClick={() => setShowMetricsDialog(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[400]
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Stack sx={{ gap: 2, mb: 2 }}>
            {emailMetrics.map((metric, i) => {
              const percentage = (metric.value / metric.maxValue) * 100
              return (
                <Box key={i}>
                  <Stack
                    direction='row'
                    sx={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        mb: 1
                      }}
                  >
                    <Typography sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 600 }} noWrap>
                        {metric.subjectName}
                      </Typography>
                    <Typography
                        color={theme.palette.grey[500]}
                        sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 600 }}
                        noWrap
                      >
                        {metric.value}
                      </Typography>
                  </Stack>
                  <BorderLinearProgress variant='determinate' value={percentage} />
                </Box>
              )
            })}
          </Stack>

          <BlueButton
            onClick={handleClickCheckEmail}
            startIcon={<CheckEmailIcon />}
            fullWidth
            sx={{ mb: 2 }}
          >
            Recheck Email
          </BlueButton>

          <Divider sx={{ my: 2 }} />

          <Stack sx={{ gap: 2 }}>
            <Box>
              <Typography sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 700 }}>
                Test Preview Email
              </Typography>
              <Typography sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 400 }} color='#8181B0'>
                It will send an email with the preview on the left to the email address below.
              </Typography>
            </Box>
            <WhiteButton startIcon={<TestEmailIcon />} fullWidth>
              Send Email Test
            </WhiteButton>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default EmailMetricsSnapshotDialog
